import React from 'react'

function MoveIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#56565A"
        d="m16.285 7.346-4.002-5.001a1 1 0 0 0-1.56 1.24l2.7 3.381H4.502A3 3 0 0 0 1.5 9.967v5.002a1 1 0 0 0 2 0V9.967a1 1 0 0 1 1-1h8.924l-2.701 3.381a1 1 0 0 0 .78 1.62 1 1 0 0 0 .78-.38l4.002-5.001a1 1 0 0 0 0-1.24Z"
      />
    </svg>
  )
}

export default MoveIcon
